import React, { useEffect, useState } from 'react';
import { ArrowRight, Hourglass } from 'lucide-react';
import type { Needs } from '../lib/needs';
import { formatAge } from '../lib/time';

interface NeedsYouStripProps {
  needs: Needs | null;
}

/**
 * The strip under the top bar (item 45): it appears only when something waits on a person, says how many and
 * for how long the oldest has waited, and opens that one. The feed reports what it already loads; nothing is
 * read again for it. Honey marks "waiting on a person" (docs/c3/DESIGN.md, colour rule 2).
 */
const NeedsYouStrip: React.FC<NeedsYouStripProps> = ({ needs }) => {
  const [now, setNow] = useState(() => Date.now());
  const shown = needs != null && needs.count > 0;

  useEffect(() => {
    if (!shown) return;
    setNow(Date.now());
    const tick = window.setInterval(() => setNow(Date.now()), 5000);
    return () => window.clearInterval(tick);
  }, [shown]);

  if (!needs || !shown) return null;
  return (
    <section className="c3-needs" aria-label="Needs you">
      <Hourglass className="c3-needs-icon" size={16} strokeWidth={1.5} aria-hidden />
      <p className="c3-needs-text">
        <b>{needs.count} awaiting your decision</b>
        {needs.oldestMs != null && <span> · oldest waiting {formatAge(needs.oldestMs, now)}</span>}
      </p>
      <button type="button" className="c3-needs-act" onClick={needs.decideNext}>
        Decide next
        <ArrowRight size={16} strokeWidth={1.5} aria-hidden />
      </button>
    </section>
  );
};

export default NeedsYouStrip;
